import React, { Component } from 'react';
import Formulario from './SaldosInicialesForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Saldos extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leerSaldo, listarClientes, listarPaises, 
            leerEstablecimiento, getModulo, parametrosEmpresa } = this.props;
        const id = match.params.id;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        if (id){
            this.setState({crear: false});
            leerSaldo(id);
        }else{
            leerEstablecimiento(modulo[8]);
        }
        listarClientes();
        listarPaises();
        parametrosEmpresa();
        getModulo(modulo[5],modulo[4]);
    }
    
    render(){
        const { registroFacturaSaldo, modificarFacturaSaldo, loader, lectura, listaP,
            listarClientes, registroClienteSaldo, estable, modulo, datos } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroFacturaSaldo : modificarFacturaSaldo;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {funcionEnvio}
                    crear = {crear}
                    lectura = {lectura}
                    obtenerPaises = { listaP }
                    listarClientes = {listarClientes}
                    registroCliente = {registroClienteSaldo}
                    listaEs = {estable}
                    modulo = {modulo}
                    datos = {datos}
                />
            </LoadMask>
        );
    }
}

export default Saldos;
